// firebaseKillswitch.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseKillswitchConfig = {
  apiKey: "AIzaSyDXggdHdPhE_R74PH3vVy55qKRppHZXVfA",
  authDomain: "switch47cashout.firebaseapp.com",
  projectId: "switch47cashout",
  storageBucket: "switch47cashout.firebasestorage.app",
  messagingSenderId: "364709681441",
  appId: "1:364709681441:web:f3cebaf61f227c2d728660",
  measurementId: "G-8P1VNWN2HB"
};

// Initialize a separate app instance
const killswitchApp = initializeApp(firebaseKillswitchConfig, "killswitch");
export const killswitchDb = getFirestore(killswitchApp);
